import React, { useEffect, useRef, useState } from "react";
import AccountFilter from "./AccountFilter";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import { useSelector } from "react-redux";
import listViewIcon from "../../../../Assets/Images/CRM/listViewIcon.svg";
import { Accordion, Button, Form, Overlay, Popover, Table } from "react-bootstrap";
import NoteIcon from "../../../../Assets/Images/CRM/notes.svg";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { commonService } from "../../../../utils/commonService";
import Loader from "../../../Loader/Loader";
import profileImage from "../../../../Assets/Images/Configuration/userNo1.png";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import WidgetNote from "../../WidgetNote";
import AddWidgetModal from "../../AddWidgetModal";
import emailIcon from "../../../../Assets/Images/Email.svg";
import send from "../../../../Assets/Images/Revenue-management/send.svg";
import { useParams } from "react-router-dom";
import Comments from "../Comments/Comment";
import moment from "moment";
import FilterModal from "../ReservationActivity/FilterModal";

const Account = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const tableData = [
        {
            RateCode: "-",
            RMS: "0",
            REV: "0",
            ADR: "0",
            LeadTime: "0",
            LOS: "0",
            "Rate Efficiency": "0",
            Occ_Threshold: "0",
            "Displaced REV": "0",
            "Displaced REV %": "0",
            "Cost/Benefit": "0",
            "Wish Rate": "0",
            Opportunity: "0",
        },
        {
            RateCode: "-",
            RMS: "0",
            REV: "0",
            ADR: "0",
            LeadTime: "0",
            LOS: "0",
            "Rate Efficiency": "0",
            Occ_Threshold: "0",
            "Displaced REV": "0",
            "Displaced REV %": "0",
            "Cost/Benefit": "0",
            "Wish Rate": "0",
            Opportunity: "0",
        },
        {
            RateCode: "-",
            RMS: "0",
            REV: "0",
            ADR: "0",
            LeadTime: "0",
            LOS: "0",
            "Rate Efficiency": "0",
            Occ_Threshold: "0",
            "Displaced REV": "0",
            "Displaced REV %": "0",
            "Cost/Benefit": "0",
            "Wish Rate": "0",
            Opportunity: "0",
        },
        {
            RateCode: "-",
            RMS: "0",
            REV: "0",
            ADR: "0",
            LeadTime: "0",
            LOS: "0",
            "Rate Efficiency": "0",
            Occ_Threshold: "0",
            "Displaced REV": "0",
            "Displaced REV %": "0",
            "Cost/Benefit": "0",
            "Wish Rate": "0",
            Opportunity: "0",
        },
        {
            RateCode: "-",
            RMS: "0",
            REV: "0",
            ADR: "0",
            LeadTime: "0",
            LOS: "0",
            "Rate Efficiency": "0",
            Occ_Threshold: "0",
            "Displaced REV": "0",
            "Displaced REV %": "0",
            "Cost/Benefit": "0",
            "Wish Rate": "0",
            Opportunity: "0",
        },
        {
            RateCode: "-",
            RMS: "0",
            REV: "0",
            ADR: "0",
            LeadTime: "0",
            LOS: "0",
            "Rate Efficiency": "0",
            Occ_Threshold: "0",
            "Displaced REV": "0",
            "Displaced REV %": "0",
            "Cost/Benefit": "0",
            "Wish Rate": "0",
            Opportunity: "0",
        },
        {
            RateCode: "-",
            RMS: "0",
            REV: "0",
            ADR: "0",
            LeadTime: "0",
            LOS: "0",
            "Rate Efficiency": "0",
            Occ_Threshold: "0",
            "Displaced REV": "0",
            "Displaced REV %": "0",
            "Cost/Benefit": "0",
            "Wish Rate": "0",
            Opportunity: "0",
        },
        {
            RateCode: "-",
            RMS: "0",
            REV: "0",
            ADR: "0",
            LeadTime: "0",
            LOS: "0",
            "Rate Efficiency": "0",
            Occ_Threshold: "0",
            "Displaced REV": "0",
            "Displaced REV %": "0",
            "Cost/Benefit": "0",
            "Wish Rate": "0",
            Opportunity: "0",
        },
        {
            RateCode: "-",
            RMS: "0",
            REV: "0",
            ADR: "0",
            LeadTime: "0",
            LOS: "0",
            "Rate Efficiency": "0",
            Occ_Threshold: "0",
            "Displaced REV": "0",
            "Displaced REV %": "0",
            "Cost/Benefit": "0",
            "Wish Rate": "0",
            Opportunity: "0",
        },
        {
            RateCode: "-",
            RMS: "0",
            REV: "0",
            ADR: "0",
            LeadTime: "0",
            LOS: "0",
            "Rate Efficiency": "0",
            Occ_Threshold: "0",
            "Displaced REV": "0",
            "Displaced REV %": "0",
            "Cost/Benefit": "0",
            "Wish Rate": "0",
            Opportunity: "0",
        },
    ];

    let rateEfficVals = [];

    const allFilterDataRef = useRef();

    const allSelectedDataRef = useRef();

    const sortingRef = useRef({
        column: "",
        order: "",
    });

    const [filterModal, setFilterModal] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
    });

    const selectedFilterRef = useRef();


    let date = new Date();
    let startDateOfYear = new Date(date.getFullYear(), date.getMonth(), 1);
    let endDateOfYear = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    let filterObj = {
        asOfDate: "",
        stayDateStart: startDateOfYear,
        stayDateEnd: endDateOfYear,
        channel: {},
        company: {},
        marketSegment: {},
        rateCode: {},
        rateCodeDescription: {},
        leadTimeOperator: ">=",
        leadTime: "-1",
        losOperator: ">=",
        los: "0",
        occ_threshold: 95,
    };
    const asOfDateFromRTK = useSelector((store) => store.headerProperty.asOfDate);

    const [showLyData, setShowLyData] = useState(false);
    const [showSideBar, setShowSideBar] = useState(false);
    const filterRef = useRef(filterObj);
    const [accountData, setAccountData] = useState(null);
    const [selectedType, setSelectedType] = useState("Rate Code");
    const [loading, setLoading] = useState(false);
    const isFilterApiCall = useRef(false);
    const totalRef = useRef();
    const callApi = useRef(false);
    const [showNoteSidebar, setShowNoteSidebar] = useState(false);
    const [widgetModal, setWidgetModal] = useState(false);
    const widgetDetailRef = useRef();
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );
    const defaultAsOfDateFromRTK = useSelector(
        (store) => store.headerProperty.defaultAsOfDate
    );
    const { snapshottitle, propertyCode, snapshotId } = useParams();

    const closeWidgetModal = () => {
        setWidgetModal(false);
    };
    const closeNoteSideBar = () => {
        setShowNoteSidebar(false);
    };

    const closeSideBar = () => {
        setShowSideBar(false);
    };

    const updateFilter = (obj) => {
        filterRef.current = obj;
        callApi.current = !callApi.current;
    };

    const getKeyFromObj = (obj) => {
        let selectedValue = [];

        Object?.entries(obj)?.map(([key, value]) => {
            if (value) {
                selectedValue = [...selectedValue, key];
            }
        });

        return selectedValue?.toString();
    };

    const getFilterData = async () => {
        setLoading(true);
        let filterDataResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.SNAPSHOT_ACCOUNT_WIDGET.GET_FILTER,
                body: { propertyCode: para?.propertyCode },
            },
            false
        );

        let response = apiResponse(false, filterDataResponse);

        if (response?.isValidate) {
            let dataFromApi = response?.data?.data;
            let companyObj = {},
                channelObj = {},
                marketSegment = {},
                rateCode = {},
                rateCodeDescription = {};

            dataFromApi?.Company?.map((item) => {
                if (item?.Company) {
                    companyObj = { ...companyObj, [item?.Company]: true };
                }
            });

            dataFromApi?.Channel?.map((item) => {
                if (item?.CombinedChannel) {
                    channelObj = { ...channelObj, [item?.CombinedChannel]: true };
                }
            });

            dataFromApi?.Marketsegments?.map((item) => {
                if (item?.market_segmentation) {
                    marketSegment = {
                        ...marketSegment,
                        [item?.market_segmentation]: true,
                    };
                }
            });

            dataFromApi?.RateCode?.map((item) => {
                if (item?.RateCode) {
                    rateCode = { ...rateCode, [item?.RateCode]: true };
                }
            });

            dataFromApi?.RateCodeDescript?.map((item) => {
                if (item?.RateCodeDescript) {
                    rateCodeDescription = {
                        ...rateCodeDescription,
                        [item?.RateCodeDescript]: true,
                    };
                }
            });

            filterRef.current.company = companyObj;
            filterRef.current.channel = channelObj;
            filterRef.current.marketSegment = marketSegment;
            filterRef.current.rateCode = rateCode;
            filterRef.current.rateCodeDescription = rateCodeDescription;
            //   filterRef.current?.occ_threshold= occ_threshold;
            isFilterApiCall.current = true;
        }
    };

    const getRateCodeData = async () => {
        setLoading(true);
        let payloadUrl = "";
        if (selectedType === "Rate Code") {
            payloadUrl = showLyData
                ? API_URL.BASE_API_URL.SnapShot +
                  API_URL.SNAPSHOT_ACCOUNT_WIDGET.GET_LY_RATECODE
                :
                API_URL.BASE_API_URL.SnapShot +
                API_URL.SNAPSHOT_ACCOUNT_WIDGET.GET_RATECODE;
        } else if (selectedType === "Rate Code Description") {
            payloadUrl = showLyData
                ? API_URL.BASE_API_URL.SnapShot +
                  API_URL.SNAPSHOT_ACCOUNT_WIDGET.GET_LY_RATECODE_DESCRIPTION
                :
                API_URL.BASE_API_URL.SnapShot +
                API_URL.SNAPSHOT_ACCOUNT_WIDGET.GET_RATECODE_DESCRIPTION;
        } else if (selectedType === "Company") {
            payloadUrl = showLyData
                ? API_URL.BASE_API_URL.SnapShot +
                  API_URL.SNAPSHOT_ACCOUNT_WIDGET.GET_LY_COMPANY
                :
                API_URL.BASE_API_URL.SnapShot +
                API_URL.SNAPSHOT_ACCOUNT_WIDGET.GET_COMPANY;
        } else if (selectedType === "Market Segment") {
            payloadUrl = showLyData
                ? API_URL.BASE_API_URL.SnapShot +
                  API_URL.SNAPSHOT_ACCOUNT_WIDGET.GET_LY_MARKET_SEGMENT
                :
                API_URL.BASE_API_URL.SnapShot +
                API_URL.SNAPSHOT_ACCOUNT_WIDGET.GET_MARKET_SEGMENT;
        } else if (selectedType === "Channel") {
            payloadUrl = showLyData
                ? API_URL.BASE_API_URL.SnapShot +
                  API_URL.SNAPSHOT_ACCOUNT_WIDGET.GET_LY_CHANNEL
                :
                API_URL.BASE_API_URL.SnapShot +
                API_URL.SNAPSHOT_ACCOUNT_WIDGET.GET_CHANNEL;
        }
        let rteCodeResponse = await apiCall(
            {
                method: "POST",
                url: payloadUrl,
                body: {
                    propertyCode: para?.propertyCode,
                    AsOfDate: commonService.getDateForNode(filterRef.current?.asOfDate),
                    startDate: commonService.getDateForNode(
                        filterRef.current?.stayDateStart
                    ),
                    endDate: commonService.getDateForNode(filterRef.current?.stayDateEnd),
                    Channel: getKeyFromObj(filterRef.current?.channel),
                    Company: getKeyFromObj(filterRef.current?.company),
                    MarketSegment: getKeyFromObj(filterRef.current?.marketSegment),
                    RateCode: getKeyFromObj(filterRef.current?.rateCode),
                    RateCodeDescript: `,${getKeyFromObj(
                        filterRef.current?.rateCodeDescription
                    )}`,
                    LeadTimeOperator: filterRef.current?.leadTimeOperator,
                    LeadTime: filterRef.current?.leadTime,
                    LOSOperator: filterRef.current?.losOperator,
                    LOS: filterRef.current?.los,
                    occ_threshold: filterRef.current?.occ_threshold,
                },
            },
            false
        );

        let response = apiResponse(false, rteCodeResponse);

        if (response?.isValidate) {
            let total = {
                roomNight: 0,
                adr: 0,
                rev: 0,
                revContri: 100,
                leadTime: 0,
                los: 0,
                rateEfficiency: 0,
                rmNights: 0,
                displacedRev: 0,
                dispalcedRevPercentage: 0,
                cost: 0,
                wishRate: 0,
                opportunity: 0,
                stlyRms: 0,
                stlyAdr: 0,
                stlyRev: 0,
                ly_roomnight: 0,
                ly_rate: 0,
                ly_revenue: 0
            };

            response?.data?.data?.map((item) => {
                total.roomNight = total.roomNight + (item?.RMS ? parseInt(item?.RMS) : 0);
                total.adr = total.adr + (item?.ADR ? parseInt(item?.ADR) : 0);
                total.rev = total.rev + (item?.REV ? parseInt(item?.REV) : 0);
                total.leadTime =
                    total.leadTime + (item?.LeadTime ? parseFloat(item?.LeadTime) : 0);
                total.los = total.los + (item?.LOS ? parseFloat(item?.LOS) : 0);
                total.rateEfficiency =
                    total.rateEfficiency +
                    (item?.["Rate Efficiency"]
                        ? parseFloat(item?.["Rate Efficiency"])
                        : 0);
                total.rmNights =
                    total.rmNights +
                    (item?.["Occ_Threshold"] ? parseFloat(item?.["Occ_Threshold"]) : 0);
                total.displacedRev =
                    total.displacedRev +
                    (item?.["Displaced REV"] ? parseFloat(item?.["Displaced REV"]) : 0);
                total.dispalcedRevPercentage =
                    total.dispalcedRevPercentage +
                    (item?.["Displaced REV %"]
                        ? parseFloat(item?.["Displaced REV %"])
                        : 0);
                total.cost =
                    total.cost +
                    (item?.["Cost/Benefit"] ? parseFloat(item?.["Cost/Benefit"]) : 0);
                total.wishRate =
                    total.wishRate +
                    (item?.["Wish Rate"] ? parseFloat(item?.["Wish Rate"]) : 0);
                total.opportunity =
                    total.opportunity +
                    (item?.["Opportunity"] ? parseFloat(item?.["Opportunity"]) : 0);
                total.stlyRms =
                    total.stlyRms + (item?.STLY_RMS ? parseInt(item?.STLY_RMS) : 0);
                total.stlyAdr =
                    total.stlyAdr + (item?.STLY_ADR ? parseInt(item?.STLY_ADR) : 0);
                total.stlyRev =
                    total.stlyRev + (item?.STLY_REV ? parseInt(item?.STLY_REV) : 0);


                total.ly_roomnight = total.ly_roomnight + (item?.ly_roomnight ? parseInt(item?.ly_roomnight) : 0);
                total.ly_rate = total.ly_rate + (item?.ly_rate ? parseInt(item?.ly_rate) : 0);
                total.ly_revenue = total.ly_revenue + (item?.ly_revenue ? parseInt(item?.ly_revenue) : 0);
            });

            totalRef.current = total;
            setAccountData(response?.data?.data);
            setLoading(false);

        }

        if (!response?.isValidate) {
            setAccountData(tableData);
            setLoading(false);
        }

        let intervalId = setInterval(function () {
            clearInterval(intervalId);
            BindFilterData();
        }, 1000);


    };




    const getAccountData = async () => {
        getRateCodeData();
    };

    const callBothApi = async () => {
        await getFilterData();
        await getAccountData();
    };

    useEffect(() => {
        if (api === 0) {
            setAccountData(tableData);
        } else {
            if (para?.asOfDate) {
                if (isFilterApiCall.current === true) {
                    getAccountData();
                } else {
                    filterRef.current.asOfDate = para?.asOfDate;
                    callBothApi();
                }
            }
        }
    }, [propertyDetailFromRTK, para?.asOfDate, callApi.current, selectedType, showLyData]);

    useEffect(() => {
        filterRef.current.asOfDate = asOfDateFromRTK;
        callApi.current = !callApi.current;
    }, [asOfDateFromRTK]);

    const [tblids, settblids] = useState({
        AccountWidgetTable: commonService.GenerateGUID(),
    });

    const rateAfficiencyAverage = (items) => {
        const sum = items.reduce((accumulator, item) => {
            const expressionResult =
                (item?.ADR / Math.round(item?.rev / item?.roomNight)) * 100;
            return accumulator + expressionResult;
        }, 0);
        return sum;
    };


    const handleSort = (n, trClassName) => {
        var table,
            rows,
            switching,
            i,
            x,
            y,
            shouldSwitch,
            dir,
            switchcount = 0;
        table = document.getElementById(
            `${tblids.AccountWidgetTable}`
        );
        switching = true;
        dir = sortingRef.current.order;

        while (switching) {
            switching = false;
            rows = table.rows;
            for (i = 2; i < rows.length - 1; i++) {
                shouldSwitch = false;
                x =
                    rows[i].getElementsByTagName("TD")[n]?.getAttribute("data-val") || "";
                y =
                    rows[i + 1].getElementsByTagName("TD")[n]?.getAttribute("data-val") ||
                    "";

                if (dir == "asc") {
                    if (parseInt(x) > parseInt(y)) {
                        shouldSwitch = true;
                        break;
                    }
                } else if (dir == "desc") {
                    if (parseInt(x) < parseInt(y)) {
                        shouldSwitch = true;
                        break;
                    }
                }
            }

            if (shouldSwitch) {
                rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
                switching = true;
                switchcount++;
            } else {
                if (switchcount == 0 && dir == "asc") {
                    dir = "desc";
                    switching = true;
                }
            }
        }

        let upIconArr = document.querySelectorAll(".up-arrow-icon");
        for (let j = 0; j < upIconArr?.length; j++) {
            upIconArr?.[j]?.setAttribute("fill", "#DFDFDF");
        }

        let downIconArr = document.querySelectorAll(".down-arrow-icon");
        for (let j = 0; j < upIconArr?.length; j++) {
            downIconArr?.[j]?.setAttribute("fill", "#DFDFDF");
        }

        let upIcon = document.querySelectorAll(`.${trClassName} .up-arrow-icon`);
        let downIcon = document.querySelectorAll(
            `.${trClassName} .down-arrow-icon`
        );

        if (sortingRef.current.order === "asc") {
            upIcon?.[0].setAttribute("fill", "#000000");
            downIcon?.[0].setAttribute("fill", "#DFDFDF");
        } else {
            downIcon?.[0].setAttribute("fill", "#000000");
            upIcon?.[0].setAttribute("fill", "#DFDFDF");
        }
    };

    const closeFilterModal = () => {
        setFilterModal({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
        selectedFilterRef.current = "";
    };

    const handleFilterBtnClick = (event) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setFilterModal({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };

    const updateFilterModal = (key, value) => {

        allSelectedDataRef.current[key] = value;
        closeFilterModal();

        handleSearch();
    };

    const handleSearch = () => {

        let table = document.getElementById(
            `${tblids.AccountWidgetTable}`
        );
        let tr = table?.getElementsByTagName("tr");

        for (let i = 0; i < tr?.length; i++) {
            let td = tr[i]?.getElementsByTagName("td");

            if (td?.length > 0) {
                const checkFilter = () => {
                    let styleForTr = "";
                    for (let t = 0; t < td?.length; t++) {
                        let Filter = Object.keys(allSelectedDataRef.current?.[t]);

                        if (Filter?.length > 0) {
                            if (!td?.[t]?.getAttribute("data-val") && styleForTr === "") {
                            } else {
                                if (
                                    allSelectedDataRef.current?.[t]?.[td?.[t]?.getAttribute("data-val")] &&
                                    styleForTr === ""
                                ) {
                                    styleForTr = "";
                                } else {
                                    styleForTr = "none";
                                }
                            }
                        }
                    }
                    return styleForTr;
                };

                tr[i].style.display = checkFilter();
            }
        }
    };

    function BindFilterData() {
        let groupingJson = {};

        const handleObj = (key, value) => {

            if (!(key in groupingJson)) {
                groupingJson[key] = {};
            }

            if (isNaN(Number(value?.replace(/[^0-9.-]/g, "")))) {
                if (!groupingJson[key][value] && value) {
                    groupingJson[key][value?.trim()] = value?.trim();

                    const sorted = Object.fromEntries(
                        Object.entries(groupingJson[key]).sort(([a], [b]) => a.localeCompare(b))
                    );

                    groupingJson[key] = sorted
                }
            } else {
                if (!groupingJson[key][value] && value) {
                    groupingJson[key][value] = value;

                    const sorted = Object.fromEntries(
                        Object.entries(groupingJson[key]).sort(([a], [b]) => Number(a.replace(/[^0-9.-]/g, "")) - Number(b.replace(/[^0-9.-]/g, "")))
                    );

                    groupingJson[key] = sorted
                }
            }
        };

        let table = document.getElementById(
            `tbody_${tblids.AccountWidgetTable}`
        );

        let tr = table?.getElementsByTagName("tr");
        for (let i = 0; i < tr?.length; i++) {
            let td = tr[i]?.getElementsByTagName("td");

            for (let t = 0; t < td?.length; t++) {
                handleObj(t, td?.[t]?.getAttribute("data-val"));
            }

        }

        allFilterDataRef.current = { ...groupingJson };
        allSelectedDataRef.current = { ...groupingJson };
    }

    return (
        <div style={{ position: "relative" }}>
            <img id={commonService.generateGlobalClickTrackerID("Account", "listviewicon", propertyCode)}
                className="heading-menu-btns filter-icon-position"
                src={listViewIcon}
                alt="listViewIcon"
                onClick={() => {
                    setShowSideBar(true);
                }}
            />

            <div className="widget-container">
                {api !== 0 && (
                    <div
                        className="gap-1 widget-container-menu"
                        style={{ right: "85px" }}
                    >
                        <Button
                            className="heading-menu-btns"
                            type="button"
                            title="Send Mail"
                        >
                            <img id={commonService.generateGlobalClickTrackerID("Account", "emailicon", propertyCode)}
                                src={emailIcon}
                                alt="emailIcon"
                                onClick={() => {
                                    commonService.fnSendWidgetMail(
                                        tblids.AccountWidgetTable,
                                        "Account",
                                        snapshotId,
                                        defaultAsOfDateFromRTK,
                                        "",
                                        para?.widgetId
                                    );
                                }}
                            />
                        </Button>
                        <Button className="heading-menu-btns" type="button">
                            <img id={commonService.generateGlobalClickTrackerID("Account", "info", propertyCode)}
                                src={infoIcon}
                                alt="info"
                                onClick={() => {
                                    widgetDetailRef.current = {
                                        widgetdetails: "",
                                        usernote: "",
                                        compName: compName?.account,
                                        widgetId: para?.widgetId,
                                    };
                                    setWidgetModal(true);
                                }}
                            />
                        </Button>
                        <Button className="heading-menu-btns" type="button">
                            <img id={commonService.generateGlobalClickTrackerID("Account", "menuicon", propertyCode)}
                                src={downloadIcon}
                                alt="menuIcon"
                                import={tblids.AccountWidgetTable}
                                onClick={() =>
                                    commonService.fnExportInCSV(
                                        tblids.AccountWidgetTable,
                                        // "Account"
                                        `${para?.propertyCode}-Account-${moment(new Date()).format(
                                            "MMDDYYYY"
                                        )}`
                                    )
                                }
                            />
                        </Button>
                    </div>
                )}
                <div className="ViewPropertySetupTable">
                    <div className="stripped__table ">
                        <div className="table-responsive tblDynamicPickupSticky">
                            <Table id={tblids.AccountWidgetTable}>
                                <thead className="tbl-header-sticky">
                                    <tr>
                                        <th style={{left: "0px", zIndex: 8}} className="border_right width150 stickycolumn my-special-sticky">
                                            <div>
                                                <Form.Select id={commonService.generateGlobalClickTrackerID("Account", "rate-code", propertyCode)}
                                                    value={selectedType}
                                                    onChange={(e) => {
                                                        setSelectedType(e.target.value);
                                                    }}
                                                >
                                                    <option value="Rate Code">Rate Code</option>
                                                    <option value="Rate Code Description">
                                                        Rate Code Description
                                                    </option>
                                                    <option value="Company">Company</option>
                                                    <option value="Market Segment">Market Segment</option>
                                                    <option value="Channel">Channel</option>
                                                </Form.Select>
                                                <span style={{ display: "none" }}>{selectedType}</span>
                                            </div>
                                        </th>
                                        <th colSpan={6} className="text-center border_right varianceField">
                                            <div className="d-flex justify-content-end align-items-center gap-2">
                                                <span className="me-5">
                                                    Production
                                                </span>
                                                <div className="form-check form-switch no-border-break from-groups jay-put-this-checkbox">
                                                    <input id={commonService.generateGlobalClickTrackerID("Account", "Production-variance", propertyCode)}
                                                        className="form-check-input me-2 cursor-pointer"
                                                        type="checkbox"
                                                        role="switch"
                                                        checked={showLyData}
                                                        onChange={() => {
                                                            setShowLyData(!showLyData);
                                                        }}
                                                    />
                                                    <label className="form-check-label">
                                                        LY DATA
                                                    </label>
                                                </div>
                                            </div>
                                        </th>

                                        <th colSpan={6} className="text-center border_right">
                                            Last Year
                                        </th>

                                        <th colSpan={5} className="text-center border_right">
                                            Stats
                                        </th>
                                        <th colSpan={3} className="text-center border_right">
                                            Displacement
                                        </th>
                                        <th colSpan={2} className="text-center">
                                            Opportunity
                                        </th>
                                    </tr>
                                    <tr>

                                        <th style={{left: "0px", zIndex: 8}} className="d-flex justify-content-between align-items-center gap-2 border_right stickycolumn my-special-sticky ">
                                            <p>{selectedType}</p>
                                            <svg id={commonService.generateGlobalClickTrackerID("Account", "svg-onclick", propertyCode)}
                                                onClick={(e) => {
                                                    if (selectedFilterRef.current === 0) {
                                                        closeFilterModal();
                                                    } else {
                                                        selectedFilterRef.current = 0;
                                                        handleFilterBtnClick(e);
                                                    }
                                                }}
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="icon icon-tabler icon-tabler-caret-down-filled cursorPointer"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                stroke-width="1.5"
                                                stroke="#000000"
                                                fill="none"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            >
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                <path
                                                    d="M18 9c.852 0 1.297 .986 .783 1.623l-.076 .084l-6 6a1 1 0 0 1 -1.32 .083l-.094 -.083l-6 -6l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057v-.118l.005 -.058l.009 -.06l.01 -.052l.032 -.108l.027 -.067l.07 -.132l.065 -.09l.073 -.081l.094 -.083l.077 -.054l.096 -.054l.036 -.017l.067 -.027l.108 -.032l.053 -.01l.06 -.01l.057 -.004l12.059 -.002z"
                                                    stroke-width="0"
                                                    fill="currentColor"
                                                />
                                            </svg>
                                        </th>

                                        <th id={commonService.generateGlobalClickTrackerID("Account", "production-room-nights", propertyCode)} className="text-center whitespace-wrap"
                                            onClick={() => {
                                                let orderForSort = "";
                                                if (sortingRef.current.column === 1) {
                                                    orderForSort =
                                                        sortingRef.current.order === "asc" ? "desc" : "asc";
                                                } else {
                                                    orderForSort = "asc";
                                                }
                                                sortingRef.current = {
                                                    column: 1,
                                                    order: orderForSort,
                                                };
                                                handleSort(1, "RMS");
                                            }}
                                        >
                                            <div className="d-flex justify-content-center align-items-center RMS">
                                                <p>Room Nights</p>
                                                <svg id={commonService.generateGlobalClickTrackerID("Account", "production-room-nights", propertyCode)}
                                                    onClick={(e) => {
                                                        if (selectedFilterRef.current === 1) {
                                                            closeFilterModal();
                                                        } else {
                                                            selectedFilterRef.current = 1;
                                                            handleFilterBtnClick(e);
                                                        }
                                                    }}
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="icon icon-tabler icon-tabler-caret-down-filled cursorPointer"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    stroke-width="1.5"
                                                    stroke="#000000"
                                                    fill="none"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                >
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path
                                                        d="M18 9c.852 0 1.297 .986 .783 1.623l-.076 .084l-6 6a1 1 0 0 1 -1.32 .083l-.094 -.083l-6 -6l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057v-.118l.005 -.058l.009 -.06l.01 -.052l.032 -.108l.027 -.067l.07 -.132l.065 -.09l.073 -.081l.094 -.083l.077 -.054l.096 -.054l.036 -.017l.067 -.027l.108 -.032l.053 -.01l.06 -.01l.057 -.004l12.059 -.002z"
                                                        stroke-width="0"
                                                        fill="currentColor"
                                                    />
                                                </svg>
                                                <div className="d-flex flex-column losTr">
                                                    <svg
                                                        className="up-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M43.7,38H8.3c-1,0-1.7-1.3-0.9-2.2l17.3-21.2c0.6-0.8,1.9-0.8,2.5,0l17.5,21.2C45.4,36.7,44.8,38,43.7,38z" />
                                                    </svg>
                                                    <svg
                                                        className="down-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M8.3,14h35.4c1,0,1.7,1.3,0.9,2.2L27.3,37.4c-0.6,0.8-1.9,0.8-2.5,0L7.3,16.2C6.6,15.3,7.2,14,8.3,14z" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </th>

                                        <th></th>
                                        <th id={commonService.generateGlobalClickTrackerID("Account", "production-adr", propertyCode)} className="text-end" onClick={() => {
                                            let orderForSort = "";
                                            if (sortingRef.current.column === 3) {
                                                orderForSort =
                                                    sortingRef.current.order === "asc" ? "desc" : "asc";
                                            } else {
                                                orderForSort = "asc";
                                            }
                                            sortingRef.current = {
                                                column: 3,
                                                order: orderForSort,
                                            };
                                            handleSort(3, "ADR");
                                        }}>
                                            <div className="d-flex justify-content-center align-items-center ADR">
                                                <p>ADR</p>
                                                <svg id={commonService.generateGlobalClickTrackerID("Account", "production-adr", propertyCode)}
                                                    onClick={(e) => {
                                                        if (selectedFilterRef.current === 3) {
                                                            closeFilterModal();
                                                        } else {
                                                            selectedFilterRef.current = 3;
                                                            handleFilterBtnClick(e);
                                                        }
                                                    }}
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="icon icon-tabler icon-tabler-caret-down-filled cursorPointer"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    stroke-width="1.5"
                                                    stroke="#000000"
                                                    fill="none"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                >
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path
                                                        d="M18 9c.852 0 1.297 .986 .783 1.623l-.076 .084l-6 6a1 1 0 0 1 -1.32 .083l-.094 -.083l-6 -6l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057v-.118l.005 -.058l.009 -.06l.01 -.052l.032 -.108l.027 -.067l.07 -.132l.065 -.09l.073 -.081l.094 -.083l.077 -.054l.096 -.054l.036 -.017l.067 -.027l.108 -.032l.053 -.01l.06 -.01l.057 -.004l12.059 -.002z"
                                                        stroke-width="0"
                                                        fill="currentColor"
                                                    />
                                                </svg>
                                                <div className="d-flex flex-column losTr">
                                                    <svg
                                                        className="up-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M43.7,38H8.3c-1,0-1.7-1.3-0.9-2.2l17.3-21.2c0.6-0.8,1.9-0.8,2.5,0l17.5,21.2C45.4,36.7,44.8,38,43.7,38z" />
                                                    </svg>
                                                    <svg
                                                        className="down-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M8.3,14h35.4c1,0,1.7,1.3,0.9,2.2L27.3,37.4c-0.6,0.8-1.9,0.8-2.5,0L7.3,16.2C6.6,15.3,7.2,14,8.3,14z" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </th>
                                        <th></th>
                                        <th id={commonService.generateGlobalClickTrackerID("Account", "production-rev", propertyCode)} className="text-end " onClick={() => {
                                            let orderForSort = "";
                                            if (sortingRef.current.column === 5) {
                                                orderForSort =
                                                    sortingRef.current.order === "asc" ? "desc" : "asc";
                                            } else {
                                                orderForSort = "asc";
                                            }
                                            sortingRef.current = {
                                                column: 5,
                                                order: orderForSort,
                                            };
                                            handleSort(5, "REV");
                                        }}>

                                            <div className="d-flex justify-content-center align-items-center REV">
                                                <p>REV</p>
                                                <svg id={commonService.generateGlobalClickTrackerID("Account", "production-rev", propertyCode)}
                                                    onClick={(e) => {
                                                        if (selectedFilterRef.current === 5) {
                                                            closeFilterModal();
                                                        } else {
                                                            selectedFilterRef.current = 5;
                                                            handleFilterBtnClick(e);
                                                        }
                                                    }}
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="icon icon-tabler icon-tabler-caret-down-filled cursorPointer"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    stroke-width="1.5"
                                                    stroke="#000000"
                                                    fill="none"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                >
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path
                                                        d="M18 9c.852 0 1.297 .986 .783 1.623l-.076 .084l-6 6a1 1 0 0 1 -1.32 .083l-.094 -.083l-6 -6l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057v-.118l.005 -.058l.009 -.06l.01 -.052l.032 -.108l.027 -.067l.07 -.132l.065 -.09l.073 -.081l.094 -.083l.077 -.054l.096 -.054l.036 -.017l.067 -.027l.108 -.032l.053 -.01l.06 -.01l.057 -.004l12.059 -.002z"
                                                        stroke-width="0"
                                                        fill="currentColor"
                                                    />
                                                </svg>
                                                <div className="d-flex flex-column losTr">
                                                    <svg
                                                        className="up-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M43.7,38H8.3c-1,0-1.7-1.3-0.9-2.2l17.3-21.2c0.6-0.8,1.9-0.8,2.5,0l17.5,21.2C45.4,36.7,44.8,38,43.7,38z" />
                                                    </svg>
                                                    <svg
                                                        className="down-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M8.3,14h35.4c1,0,1.7,1.3,0.9,2.2L27.3,37.4c-0.6,0.8-1.9,0.8-2.5,0L7.3,16.2C6.6,15.3,7.2,14,8.3,14z" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </th>
                                        <th className="border_right"></th>



                                        <th id={commonService.generateGlobalClickTrackerID("Account", "last-year-room-nights", propertyCode)} className="text-center whitespace-wrap" onClick={() => {
                                            let orderForSort = "";
                                            if (sortingRef.current.column === 7) {
                                                orderForSort =
                                                    sortingRef.current.order === "asc" ? "desc" : "asc";
                                            } else {
                                                orderForSort = "asc";
                                            }
                                            sortingRef.current = {
                                                column: 7,
                                                order: orderForSort,
                                            };
                                            handleSort(7, "ly_roomnight");
                                        }}>
                                            <div className="d-flex justify-content-center align-items-center ly_roomnight">
                                                <p>Room Nights</p>
                                                <svg id={commonService.generateGlobalClickTrackerID("Account", "last-year-room-nights", propertyCode)}
                                                    onClick={(e) => {
                                                        if (selectedFilterRef.current === 7) {
                                                            closeFilterModal();
                                                        } else {
                                                            selectedFilterRef.current = 7;
                                                            handleFilterBtnClick(e);
                                                        }
                                                    }}
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="icon icon-tabler icon-tabler-caret-down-filled cursorPointer"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    stroke-width="1.5"
                                                    stroke="#000000"
                                                    fill="none"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                >
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path
                                                        d="M18 9c.852 0 1.297 .986 .783 1.623l-.076 .084l-6 6a1 1 0 0 1 -1.32 .083l-.094 -.083l-6 -6l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057v-.118l.005 -.058l.009 -.06l.01 -.052l.032 -.108l.027 -.067l.07 -.132l.065 -.09l.073 -.081l.094 -.083l.077 -.054l.096 -.054l.036 -.017l.067 -.027l.108 -.032l.053 -.01l.06 -.01l.057 -.004l12.059 -.002z"
                                                        stroke-width="0"
                                                        fill="currentColor"
                                                    />
                                                </svg>
                                                <div className="d-flex flex-column losTr">
                                                    <svg
                                                        className="up-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M43.7,38H8.3c-1,0-1.7-1.3-0.9-2.2l17.3-21.2c0.6-0.8,1.9-0.8,2.5,0l17.5,21.2C45.4,36.7,44.8,38,43.7,38z" />
                                                    </svg>
                                                    <svg
                                                        className="down-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M8.3,14h35.4c1,0,1.7,1.3,0.9,2.2L27.3,37.4c-0.6,0.8-1.9,0.8-2.5,0L7.3,16.2C6.6,15.3,7.2,14,8.3,14z" />
                                                    </svg>
                                                </div>
                                            </div>

                                        </th>
                                        <th></th>
                                        <th id={commonService.generateGlobalClickTrackerID("Account", "last-year-adr", propertyCode)} className="text-end" onClick={() => {
                                            let orderForSort = "";
                                            if (sortingRef.current.column === 9) {
                                                orderForSort =
                                                    sortingRef.current.order === "asc" ? "desc" : "asc";
                                            } else {
                                                orderForSort = "asc";
                                            }
                                            sortingRef.current = {
                                                column: 9,
                                                order: orderForSort,
                                            };
                                            handleSort(9, "ly_rate");
                                        }}>
                                            <div className="d-flex justify-content-center align-items-center ly_rate">
                                                <p>ADR</p>
                                                <svg id={commonService.generateGlobalClickTrackerID("Account", "last-year-adr", propertyCode)}
                                                    onClick={(e) => {
                                                        if (selectedFilterRef.current === 9) {
                                                            closeFilterModal();
                                                        } else {
                                                            selectedFilterRef.current = 9;
                                                            handleFilterBtnClick(e);
                                                        }
                                                    }}
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="icon icon-tabler icon-tabler-caret-down-filled cursorPointer"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    stroke-width="1.5"
                                                    stroke="#000000"
                                                    fill="none"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                >
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path
                                                        d="M18 9c.852 0 1.297 .986 .783 1.623l-.076 .084l-6 6a1 1 0 0 1 -1.32 .083l-.094 -.083l-6 -6l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057v-.118l.005 -.058l.009 -.06l.01 -.052l.032 -.108l.027 -.067l.07 -.132l.065 -.09l.073 -.081l.094 -.083l.077 -.054l.096 -.054l.036 -.017l.067 -.027l.108 -.032l.053 -.01l.06 -.01l.057 -.004l12.059 -.002z"
                                                        stroke-width="0"
                                                        fill="currentColor"
                                                    />
                                                </svg>
                                                <div className="d-flex flex-column losTr">
                                                    <svg
                                                        className="up-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M43.7,38H8.3c-1,0-1.7-1.3-0.9-2.2l17.3-21.2c0.6-0.8,1.9-0.8,2.5,0l17.5,21.2C45.4,36.7,44.8,38,43.7,38z" />
                                                    </svg>
                                                    <svg
                                                        className="down-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M8.3,14h35.4c1,0,1.7,1.3,0.9,2.2L27.3,37.4c-0.6,0.8-1.9,0.8-2.5,0L7.3,16.2C6.6,15.3,7.2,14,8.3,14z" />
                                                    </svg>
                                                </div>
                                            </div>

                                        </th>
                                        <th></th>
                                        <th id={commonService.generateGlobalClickTrackerID("Account", "last-year-rev", propertyCode)} className="text-end " onClick={() => {
                                            let orderForSort = "";
                                            if (sortingRef.current.column === 11) {
                                                orderForSort =
                                                    sortingRef.current.order === "asc" ? "desc" : "asc";
                                            } else {
                                                orderForSort = "asc";
                                            }
                                            sortingRef.current = {
                                                column: 11,
                                                order: orderForSort,
                                            };
                                            handleSort(11, "ly_revenue");
                                        }}>

                                            <div className="d-flex justify-content-center align-items-center ly_revenue">
                                                <p>REV</p>
                                                <svg id={commonService.generateGlobalClickTrackerID("Account", "last-year-rev", propertyCode)}
                                                    onClick={(e) => {
                                                        if (selectedFilterRef.current === 11) {
                                                            closeFilterModal();
                                                        } else {
                                                            selectedFilterRef.current = 11;
                                                            handleFilterBtnClick(e);
                                                        }
                                                    }}
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="icon icon-tabler icon-tabler-caret-down-filled cursorPointer"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    stroke-width="1.5"
                                                    stroke="#000000"
                                                    fill="none"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                >
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path
                                                        d="M18 9c.852 0 1.297 .986 .783 1.623l-.076 .084l-6 6a1 1 0 0 1 -1.32 .083l-.094 -.083l-6 -6l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057v-.118l.005 -.058l.009 -.06l.01 -.052l.032 -.108l.027 -.067l.07 -.132l.065 -.09l.073 -.081l.094 -.083l.077 -.054l.096 -.054l.036 -.017l.067 -.027l.108 -.032l.053 -.01l.06 -.01l.057 -.004l12.059 -.002z"
                                                        stroke-width="0"
                                                        fill="currentColor"
                                                    />
                                                </svg>
                                                <div className="d-flex flex-column losTr">
                                                    <svg
                                                        className="up-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M43.7,38H8.3c-1,0-1.7-1.3-0.9-2.2l17.3-21.2c0.6-0.8,1.9-0.8,2.5,0l17.5,21.2C45.4,36.7,44.8,38,43.7,38z" />
                                                    </svg>
                                                    <svg
                                                        className="down-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M8.3,14h35.4c1,0,1.7,1.3,0.9,2.2L27.3,37.4c-0.6,0.8-1.9,0.8-2.5,0L7.3,16.2C6.6,15.3,7.2,14,8.3,14z" />
                                                    </svg>
                                                </div>
                                            </div>

                                        </th>
                                        <th className="border_right"></th>




                                        <th id={commonService.generateGlobalClickTrackerID("Account", "stats-rev-contribution", propertyCode)} className="text-center whitespace-wrap" onClick={() => {
                                            let orderForSort = "";
                                            if (sortingRef.current.column === 13) {
                                                orderForSort =
                                                    sortingRef.current.order === "asc" ? "desc" : "asc";
                                            } else {
                                                orderForSort = "asc";
                                            }
                                            sortingRef.current = {
                                                column: 13,
                                                order: orderForSort,
                                            };
                                            handleSort(13, "revContri");
                                        }}>


                                            <div className="d-flex justify-content-center align-items-center revContri">
                                                <p>REV Contribution</p>
                                                <svg id={commonService.generateGlobalClickTrackerID("Account", "stats-rev-contribution", propertyCode)}
                                                    onClick={(e) => {
                                                        if (selectedFilterRef.current === 13) {
                                                            closeFilterModal();
                                                        } else {
                                                            selectedFilterRef.current = 13;
                                                            handleFilterBtnClick(e);
                                                        }
                                                    }}
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="icon icon-tabler icon-tabler-caret-down-filled cursorPointer"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    stroke-width="1.5"
                                                    stroke="#000000"
                                                    fill="none"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                >
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path
                                                        d="M18 9c.852 0 1.297 .986 .783 1.623l-.076 .084l-6 6a1 1 0 0 1 -1.32 .083l-.094 -.083l-6 -6l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057v-.118l.005 -.058l.009 -.06l.01 -.052l.032 -.108l.027 -.067l.07 -.132l.065 -.09l.073 -.081l.094 -.083l.077 -.054l.096 -.054l.036 -.017l.067 -.027l.108 -.032l.053 -.01l.06 -.01l.057 -.004l12.059 -.002z"
                                                        stroke-width="0"
                                                        fill="currentColor"
                                                    />
                                                </svg>
                                                <div className="d-flex flex-column losTr">
                                                    <svg
                                                        className="up-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M43.7,38H8.3c-1,0-1.7-1.3-0.9-2.2l17.3-21.2c0.6-0.8,1.9-0.8,2.5,0l17.5,21.2C45.4,36.7,44.8,38,43.7,38z" />
                                                    </svg>
                                                    <svg
                                                        className="down-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M8.3,14h35.4c1,0,1.7,1.3,0.9,2.2L27.3,37.4c-0.6,0.8-1.9,0.8-2.5,0L7.3,16.2C6.6,15.3,7.2,14,8.3,14z" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </th>
                                        <th id={commonService.generateGlobalClickTrackerID("Account", "stats-lead-time", propertyCode)} className="text-center whitespace-wrap" onClick={() => {
                                            let orderForSort = "";
                                            if (sortingRef.current.column === 14) {
                                                orderForSort =
                                                    sortingRef.current.order === "asc" ? "desc" : "asc";
                                            } else {
                                                orderForSort = "asc";
                                            }
                                            sortingRef.current = {
                                                column: 14,
                                                order: orderForSort,
                                            };
                                            handleSort(14, "LeadTime");
                                        }}>
                                            <div className="d-flex justify-content-center align-items-center LeadTime">
                                                <p>Lead Time</p>
                                                <svg id={commonService.generateGlobalClickTrackerID("Account", "stats-lead-time", propertyCode)}
                                                    onClick={(e) => {
                                                        if (selectedFilterRef.current === 14) {
                                                            closeFilterModal();
                                                        } else {
                                                            selectedFilterRef.current = 14;
                                                            handleFilterBtnClick(e);
                                                        }
                                                    }}
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="icon icon-tabler icon-tabler-caret-down-filled cursorPointer"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    stroke-width="1.5"
                                                    stroke="#000000"
                                                    fill="none"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                >
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path
                                                        d="M18 9c.852 0 1.297 .986 .783 1.623l-.076 .084l-6 6a1 1 0 0 1 -1.32 .083l-.094 -.083l-6 -6l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057v-.118l.005 -.058l.009 -.06l.01 -.052l.032 -.108l.027 -.067l.07 -.132l.065 -.09l.073 -.081l.094 -.083l.077 -.054l.096 -.054l.036 -.017l.067 -.027l.108 -.032l.053 -.01l.06 -.01l.057 -.004l12.059 -.002z"
                                                        stroke-width="0"
                                                        fill="currentColor"
                                                    />
                                                </svg>
                                                <div className="d-flex flex-column losTr">
                                                    <svg
                                                        className="up-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M43.7,38H8.3c-1,0-1.7-1.3-0.9-2.2l17.3-21.2c0.6-0.8,1.9-0.8,2.5,0l17.5,21.2C45.4,36.7,44.8,38,43.7,38z" />
                                                    </svg>
                                                    <svg
                                                        className="down-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M8.3,14h35.4c1,0,1.7,1.3,0.9,2.2L27.3,37.4c-0.6,0.8-1.9,0.8-2.5,0L7.3,16.2C6.6,15.3,7.2,14,8.3,14z" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </th>
                                        <th id={commonService.generateGlobalClickTrackerID("Account", "stats-los", propertyCode)} className="text-center" onClick={() => {
                                            let orderForSort = "";
                                            if (sortingRef.current.column === 15) {
                                                orderForSort =
                                                    sortingRef.current.order === "asc" ? "desc" : "asc";
                                            } else {
                                                orderForSort = "asc";
                                            }
                                            sortingRef.current = {
                                                column: 15,
                                                order: orderForSort,
                                            };
                                            handleSort(15, "LOS");
                                        }}>

                                            <div className="d-flex justify-content-center align-items-center LOS">
                                                <p>LOS</p>
                                                <svg id={commonService.generateGlobalClickTrackerID("Account", "stats-los", propertyCode)}
                                                    onClick={(e) => {
                                                        if (selectedFilterRef.current === 15) {
                                                            closeFilterModal();
                                                        } else {
                                                            selectedFilterRef.current = 15;
                                                            handleFilterBtnClick(e);
                                                        }
                                                    }}
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="icon icon-tabler icon-tabler-caret-down-filled cursorPointer"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    stroke-width="1.5"
                                                    stroke="#000000"
                                                    fill="none"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                >
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path
                                                        d="M18 9c.852 0 1.297 .986 .783 1.623l-.076 .084l-6 6a1 1 0 0 1 -1.32 .083l-.094 -.083l-6 -6l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057v-.118l.005 -.058l.009 -.06l.01 -.052l.032 -.108l.027 -.067l.07 -.132l.065 -.09l.073 -.081l.094 -.083l.077 -.054l.096 -.054l.036 -.017l.067 -.027l.108 -.032l.053 -.01l.06 -.01l.057 -.004l12.059 -.002z"
                                                        stroke-width="0"
                                                        fill="currentColor"
                                                    />
                                                </svg>
                                                <div className="d-flex flex-column losTr">
                                                    <svg
                                                        className="up-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M43.7,38H8.3c-1,0-1.7-1.3-0.9-2.2l17.3-21.2c0.6-0.8,1.9-0.8,2.5,0l17.5,21.2C45.4,36.7,44.8,38,43.7,38z" />
                                                    </svg>
                                                    <svg
                                                        className="down-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M8.3,14h35.4c1,0,1.7,1.3,0.9,2.2L27.3,37.4c-0.6,0.8-1.9,0.8-2.5,0L7.3,16.2C6.6,15.3,7.2,14,8.3,14z" />
                                                    </svg>
                                                </div>
                                            </div>

                                        </th>
                                        <th id={commonService.generateGlobalClickTrackerID("Account", "stats-rate-efficiency", propertyCode)} className="text-center whitespace-wrap" onClick={() => {
                                            let orderForSort = "";
                                            if (sortingRef.current.column === 16) {
                                                orderForSort =
                                                    sortingRef.current.order === "asc" ? "desc" : "asc";
                                            } else {
                                                orderForSort = "asc";
                                            }
                                            sortingRef.current = {
                                                column: 16,
                                                order: orderForSort,
                                            };
                                            handleSort(16, "RateEfficiency");
                                        }}>

                                            

                                            <div className="d-flex justify-content-center align-items-center RateEfficiency">
                                                <p>Rate Efficiency</p>
                                                <svg id={commonService.generateGlobalClickTrackerID("Account", "stats-rate-efficiency", propertyCode)}
                                                    onClick={(e) => {
                                                        if (selectedFilterRef.current === 16) {
                                                            closeFilterModal();
                                                        } else {
                                                            selectedFilterRef.current = 16;
                                                            handleFilterBtnClick(e);
                                                        }
                                                    }}
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="icon icon-tabler icon-tabler-caret-down-filled cursorPointer"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    stroke-width="1.5"
                                                    stroke="#000000"
                                                    fill="none"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                >
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path
                                                        d="M18 9c.852 0 1.297 .986 .783 1.623l-.076 .084l-6 6a1 1 0 0 1 -1.32 .083l-.094 -.083l-6 -6l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057v-.118l.005 -.058l.009 -.06l.01 -.052l.032 -.108l.027 -.067l.07 -.132l.065 -.09l.073 -.081l.094 -.083l.077 -.054l.096 -.054l.036 -.017l.067 -.027l.108 -.032l.053 -.01l.06 -.01l.057 -.004l12.059 -.002z"
                                                        stroke-width="0"
                                                        fill="currentColor"
                                                    />
                                                </svg>
                                                <div className="d-flex flex-column losTr">
                                                    <svg
                                                        className="up-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M43.7,38H8.3c-1,0-1.7-1.3-0.9-2.2l17.3-21.2c0.6-0.8,1.9-0.8,2.5,0l17.5,21.2C45.4,36.7,44.8,38,43.7,38z" />
                                                    </svg>
                                                    <svg
                                                        className="down-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M8.3,14h35.4c1,0,1.7,1.3,0.9,2.2L27.3,37.4c-0.6,0.8-1.9,0.8-2.5,0L7.3,16.2C6.6,15.3,7.2,14,8.3,14z" />
                                                    </svg>
                                                </div>
                                            </div>

                                        </th>
                                        <th id={commonService.generateGlobalClickTrackerID("Account", "stats", propertyCode)} className="text-center border_right width150" onClick={() => {
                                            let orderForSort = "";
                                            if (sortingRef.current.column === 17) {
                                                orderForSort =
                                                    sortingRef.current.order === "asc" ? "desc" : "asc";
                                            } else {
                                                orderForSort = "asc";
                                            }
                                            sortingRef.current = {
                                                column: 17,
                                                order: orderForSort,
                                            };
                                            handleSort(17, "OccThreshold");
                                        }}>

                                            <div className="d-flex justify-content-center align-items-center OccThreshold">
                                                <p>{`Occ Threshold ${filterRef.current?.occ_threshold}%`}</p>
                                                <svg id={commonService.generateGlobalClickTrackerID("Account", "stats", propertyCode)}
                                                    onClick={(e) => {
                                                        if (selectedFilterRef.current === 17) {
                                                            closeFilterModal();
                                                        } else {
                                                            selectedFilterRef.current = 17;
                                                            handleFilterBtnClick(e);
                                                        }
                                                    }}
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="icon icon-tabler icon-tabler-caret-down-filled cursorPointer"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    stroke-width="1.5"
                                                    stroke="#000000"
                                                    fill="none"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                >
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path
                                                        d="M18 9c.852 0 1.297 .986 .783 1.623l-.076 .084l-6 6a1 1 0 0 1 -1.32 .083l-.094 -.083l-6 -6l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057v-.118l.005 -.058l.009 -.06l.01 -.052l.032 -.108l.027 -.067l.07 -.132l.065 -.09l.073 -.081l.094 -.083l.077 -.054l.096 -.054l.036 -.017l.067 -.027l.108 -.032l.053 -.01l.06 -.01l.057 -.004l12.059 -.002z"
                                                        stroke-width="0"
                                                        fill="currentColor"
                                                    />
                                                </svg>
                                                <div className="d-flex flex-column losTr">
                                                    <svg
                                                        className="up-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M43.7,38H8.3c-1,0-1.7-1.3-0.9-2.2l17.3-21.2c0.6-0.8,1.9-0.8,2.5,0l17.5,21.2C45.4,36.7,44.8,38,43.7,38z" />
                                                    </svg>
                                                    <svg
                                                        className="down-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M8.3,14h35.4c1,0,1.7,1.3,0.9,2.2L27.3,37.4c-0.6,0.8-1.9,0.8-2.5,0L7.3,16.2C6.6,15.3,7.2,14,8.3,14z" />
                                                    </svg>
                                                </div>
                                            </div>


                                        </th>
                                        <th id={commonService.generateGlobalClickTrackerID("Account", "displacement-displaced-rev", propertyCode)} className="text-end whitespace-wrap" onClick={() => {
                                            let orderForSort = "";
                                            if (sortingRef.current.column === 18) {
                                                orderForSort =
                                                    sortingRef.current.order === "asc" ? "desc" : "asc";
                                            } else {
                                                orderForSort = "asc";
                                            }
                                            sortingRef.current = {
                                                column: 18,
                                                order: orderForSort,
                                            };
                                            handleSort(18, "DisplacedREV");
                                        }}>


                                            <div className="d-flex justify-content-center align-items-center DisplacedREV">
                                                <p>Displaced REV</p>
                                                <svg id={commonService.generateGlobalClickTrackerID("Account", "displacement-displaced-rev", propertyCode)}
                                                    onClick={(e) => {
                                                        if (selectedFilterRef.current === 18) {
                                                            closeFilterModal();
                                                        } else {
                                                            selectedFilterRef.current = 18;
                                                            handleFilterBtnClick(e);
                                                        }
                                                    }}
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="icon icon-tabler icon-tabler-caret-down-filled cursorPointer"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    stroke-width="1.5"
                                                    stroke="#000000"
                                                    fill="none"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                >
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path
                                                        d="M18 9c.852 0 1.297 .986 .783 1.623l-.076 .084l-6 6a1 1 0 0 1 -1.32 .083l-.094 -.083l-6 -6l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057v-.118l.005 -.058l.009 -.06l.01 -.052l.032 -.108l.027 -.067l.07 -.132l.065 -.09l.073 -.081l.094 -.083l.077 -.054l.096 -.054l.036 -.017l.067 -.027l.108 -.032l.053 -.01l.06 -.01l.057 -.004l12.059 -.002z"
                                                        stroke-width="0"
                                                        fill="currentColor"
                                                    />
                                                </svg>
                                                <div className="d-flex flex-column losTr">
                                                    <svg
                                                        className="up-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M43.7,38H8.3c-1,0-1.7-1.3-0.9-2.2l17.3-21.2c0.6-0.8,1.9-0.8,2.5,0l17.5,21.2C45.4,36.7,44.8,38,43.7,38z" />
                                                    </svg>
                                                    <svg
                                                        className="down-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M8.3,14h35.4c1,0,1.7,1.3,0.9,2.2L27.3,37.4c-0.6,0.8-1.9,0.8-2.5,0L7.3,16.2C6.6,15.3,7.2,14,8.3,14z" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </th>
                                        <th id={commonService.generateGlobalClickTrackerID("Account", "displacement-displaced-rev", propertyCode)} className="text-center whitespace-wrap" onClick={() => {
                                            let orderForSort = "";
                                            if (sortingRef.current.column === 19) {
                                                orderForSort =
                                                    sortingRef.current.order === "asc" ? "desc" : "asc";
                                            } else {
                                                orderForSort = "asc";
                                            }
                                            sortingRef.current = {
                                                column: 19,
                                                order: orderForSort,
                                            };
                                            handleSort(19, "DisplacedREVPer");
                                        }}>

                                            <div className="d-flex justify-content-center align-items-center DisplacedREVPer">
                                                <p> Displaced REV %</p>
                                                <svg id={commonService.generateGlobalClickTrackerID("Account", "displacement-displaced-rev", propertyCode)}
                                                    onClick={(e) => {
                                                        if (selectedFilterRef.current === 19) {
                                                            closeFilterModal();
                                                        } else {
                                                            selectedFilterRef.current = 19;
                                                            handleFilterBtnClick(e);
                                                        }
                                                    }}
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="icon icon-tabler icon-tabler-caret-down-filled cursorPointer"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    stroke-width="1.5"
                                                    stroke="#000000"
                                                    fill="none"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                >
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path
                                                        d="M18 9c.852 0 1.297 .986 .783 1.623l-.076 .084l-6 6a1 1 0 0 1 -1.32 .083l-.094 -.083l-6 -6l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057v-.118l.005 -.058l.009 -.06l.01 -.052l.032 -.108l.027 -.067l.07 -.132l.065 -.09l.073 -.081l.094 -.083l.077 -.054l.096 -.054l.036 -.017l.067 -.027l.108 -.032l.053 -.01l.06 -.01l.057 -.004l12.059 -.002z"
                                                        stroke-width="0"
                                                        fill="currentColor"
                                                    />
                                                </svg>
                                                <div className="d-flex flex-column losTr">
                                                    <svg
                                                        className="up-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M43.7,38H8.3c-1,0-1.7-1.3-0.9-2.2l17.3-21.2c0.6-0.8,1.9-0.8,2.5,0l17.5,21.2C45.4,36.7,44.8,38,43.7,38z" />
                                                    </svg>
                                                    <svg
                                                        className="down-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M8.3,14h35.4c1,0,1.7,1.3,0.9,2.2L27.3,37.4c-0.6,0.8-1.9,0.8-2.5,0L7.3,16.2C6.6,15.3,7.2,14,8.3,14z" />
                                                    </svg>
                                                </div>
                                            </div>

                                        </th>
                                        <th id={commonService.generateGlobalClickTrackerID("Account", "displacement-cost-benefit", propertyCode)} className="text-end border_right whitespace-wrap" onClick={() => {
                                            let orderForSort = "";
                                            if (sortingRef.current.column === 20) {
                                                orderForSort =
                                                    sortingRef.current.order === "asc" ? "desc" : "asc";
                                            } else {
                                                orderForSort = "asc";
                                            }
                                            sortingRef.current = {
                                                column: 20,
                                                order: orderForSort,
                                            };
                                            handleSort(20, "CostBenefit");
                                        }}>



                                            <div className="d-flex justify-content-center align-items-center CostBenefit">
                                                <p> Cost/Benefit</p>
                                                <svg id={commonService.generateGlobalClickTrackerID("Account", "displacement-cost-benefit", propertyCode)}
                                                    onClick={(e) => {
                                                        if (selectedFilterRef.current === 20) {
                                                            closeFilterModal();
                                                        } else {
                                                            selectedFilterRef.current = 20;
                                                            handleFilterBtnClick(e);
                                                        }
                                                    }}
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="icon icon-tabler icon-tabler-caret-down-filled cursorPointer"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    stroke-width="1.5"
                                                    stroke="#000000"
                                                    fill="none"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                >
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path
                                                        d="M18 9c.852 0 1.297 .986 .783 1.623l-.076 .084l-6 6a1 1 0 0 1 -1.32 .083l-.094 -.083l-6 -6l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057v-.118l.005 -.058l.009 -.06l.01 -.052l.032 -.108l.027 -.067l.07 -.132l.065 -.09l.073 -.081l.094 -.083l.077 -.054l.096 -.054l.036 -.017l.067 -.027l.108 -.032l.053 -.01l.06 -.01l.057 -.004l12.059 -.002z"
                                                        stroke-width="0"
                                                        fill="currentColor"
                                                    />
                                                </svg>
                                                <div className="d-flex flex-column losTr">
                                                    <svg
                                                        className="up-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M43.7,38H8.3c-1,0-1.7-1.3-0.9-2.2l17.3-21.2c0.6-0.8,1.9-0.8,2.5,0l17.5,21.2C45.4,36.7,44.8,38,43.7,38z" />
                                                    </svg>
                                                    <svg
                                                        className="down-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M8.3,14h35.4c1,0,1.7,1.3,0.9,2.2L27.3,37.4c-0.6,0.8-1.9,0.8-2.5,0L7.3,16.2C6.6,15.3,7.2,14,8.3,14z" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </th>
                                        <th id={commonService.generateGlobalClickTrackerID("Account", "opportunity-wish-rate", propertyCode)} className="text-end whitespace-wrap" onClick={() => {
                                            let orderForSort = "";
                                            if (sortingRef.current.column === 21) {
                                                orderForSort =
                                                    sortingRef.current.order === "asc" ? "desc" : "asc";
                                            } else {
                                                orderForSort = "asc";
                                            }
                                            sortingRef.current = {
                                                column: 21,
                                                order: orderForSort,
                                            };
                                            handleSort(21, "WishRate");
                                        }}>
                                            <div className="d-flex justify-content-center align-items-center WishRate">
                                                <p> Wish Rate</p>
                                                <svg id={commonService.generateGlobalClickTrackerID("Account", "opportunity-wish-rate", propertyCode)}
                                                    onClick={(e) => {
                                                        if (selectedFilterRef.current === 21) {
                                                            closeFilterModal();
                                                        } else {
                                                            selectedFilterRef.current = 21;
                                                            handleFilterBtnClick(e);
                                                        }
                                                    }}
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="icon icon-tabler icon-tabler-caret-down-filled cursorPointer"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    stroke-width="1.5"
                                                    stroke="#000000"
                                                    fill="none"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                >
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path
                                                        d="M18 9c.852 0 1.297 .986 .783 1.623l-.076 .084l-6 6a1 1 0 0 1 -1.32 .083l-.094 -.083l-6 -6l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057v-.118l.005 -.058l.009 -.06l.01 -.052l.032 -.108l.027 -.067l.07 -.132l.065 -.09l.073 -.081l.094 -.083l.077 -.054l.096 -.054l.036 -.017l.067 -.027l.108 -.032l.053 -.01l.06 -.01l.057 -.004l12.059 -.002z"
                                                        stroke-width="0"
                                                        fill="currentColor"
                                                    />
                                                </svg>
                                                <div className="d-flex flex-column losTr">
                                                    <svg
                                                        className="up-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M43.7,38H8.3c-1,0-1.7-1.3-0.9-2.2l17.3-21.2c0.6-0.8,1.9-0.8,2.5,0l17.5,21.2C45.4,36.7,44.8,38,43.7,38z" />
                                                    </svg>
                                                    <svg
                                                        className="down-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M8.3,14h35.4c1,0,1.7,1.3,0.9,2.2L27.3,37.4c-0.6,0.8-1.9,0.8-2.5,0L7.3,16.2C6.6,15.3,7.2,14,8.3,14z" />
                                                    </svg>
                                                </div>
                                            </div>

                                        </th>
                                        <th id={commonService.generateGlobalClickTrackerID("Account", "opportunity-opportunity", propertyCode)} className="text-end" onClick={() => {
                                            let orderForSort = "";
                                            if (sortingRef.current.column === 22) {
                                                orderForSort =
                                                    sortingRef.current.order === "asc" ? "desc" : "asc";
                                            } else {
                                                orderForSort = "asc";
                                            }
                                            sortingRef.current = {
                                                column: 22,
                                                order: orderForSort,
                                            };
                                            handleSort(22, "Opportunity");
                                        }}>
                                            <div className="d-flex justify-content-center align-items-center Opportunity">
                                                <p>Opportunity</p>
                                                <svg id={commonService.generateGlobalClickTrackerID("Account", "opportunity-opportunity", propertyCode)}
                                                    onClick={(e) => {
                                                        if (selectedFilterRef.current === 22) {
                                                            closeFilterModal();
                                                        } else {
                                                            selectedFilterRef.current = 22;
                                                            handleFilterBtnClick(e);
                                                        }
                                                    }}
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="icon icon-tabler icon-tabler-caret-down-filled cursorPointer"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    stroke-width="1.5"
                                                    stroke="#000000"
                                                    fill="none"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                >
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path
                                                        d="M18 9c.852 0 1.297 .986 .783 1.623l-.076 .084l-6 6a1 1 0 0 1 -1.32 .083l-.094 -.083l-6 -6l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057v-.118l.005 -.058l.009 -.06l.01 -.052l.032 -.108l.027 -.067l.07 -.132l.065 -.09l.073 -.081l.094 -.083l.077 -.054l.096 -.054l.036 -.017l.067 -.027l.108 -.032l.053 -.01l.06 -.01l.057 -.004l12.059 -.002z"
                                                        stroke-width="0"
                                                        fill="currentColor"
                                                    />
                                                </svg>
                                                <div className="d-flex flex-column losTr">
                                                    <svg
                                                        className="up-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M43.7,38H8.3c-1,0-1.7-1.3-0.9-2.2l17.3-21.2c0.6-0.8,1.9-0.8,2.5,0l17.5,21.2C45.4,36.7,44.8,38,43.7,38z" />
                                                    </svg>
                                                    <svg
                                                        className="down-arrow-icon"
                                                        fill="#DFDFDF"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="9px"
                                                        height="9px"
                                                        viewBox="0 0 52 52"
                                                        enable-background="new 0 0 52 52"
                                                    >
                                                        <path d="M8.3,14h35.4c1,0,1.7,1.3,0.9,2.2L27.3,37.4c-0.6,0.8-1.9,0.8-2.5,0L7.3,16.2C6.6,15.3,7.2,14,8.3,14z" />
                                                    </svg>
                                                </div>
                                            </div>

                                        </th>
                                    </tr>
                                </thead>
                                <tbody id={"tbody_" + tblids.AccountWidgetTable}>
                                    {loading ? (
                                        <tr style={{ height: "80px", position: "relative" }}>
                                            <Loader />
                                        </tr>
                                    ) : (
                                        accountData?.map((item, index) => {
                                            const rateEfficVal = (
                                                ((item?.ADR || 0) /
                                                    Math.round(
                                                        totalRef.current?.rev / totalRef.current?.roomNight
                                                    )) *
                                                100
                                            ).toFixed(1);

                                            rateEfficVals.push(parseFloat(rateEfficVal));

                                            const averageRateEffic = (
                                                rateEfficVals.reduce(
                                                    (accumulator, currentValue) =>
                                                        accumulator + currentValue,
                                                    0
                                                ) / (rateEfficVals.length || 1)
                                            ).toFixed(1);

                                            let keyName = "";
                                            if (selectedType === "Rate Code") {
                                                keyName = "RateCode";
                                            } else if (selectedType === "Rate Code Description") {
                                                keyName = "RateCodeDescript";
                                            } else if (selectedType === "Company") {
                                                keyName = "Company";
                                            } else if (selectedType === "Market Segment") {
                                                keyName = "MarketSegment";
                                            } else if (selectedType === "Channel") {
                                                keyName = "Channel";
                                            }

                                            let varientRms =
                                                (item?.RMS ? parseInt(item?.RMS) : 0) -
                                                (item?.STLY_RMS ? parseInt(item?.STLY_RMS) : 0);
                                            let varientAdr =
                                                (item?.ADR ? parseInt(item?.ADR) : 0) -
                                                (item?.STLY_ADR ? parseInt(item?.STLY_ADR) : 0);
                                            let varientRev =
                                                (item?.REV ? parseInt(item?.REV) : 0) -
                                                (item?.STLY_REV ? parseInt(item?.STLY_REV) : 0);



                                            let LastYear_varientRms =
                                                (item?.RMS ? parseInt(item?.RMS) : 0) -
                                                (item?.ly_roomnight ? parseInt(item?.ly_roomnight) : 0);
                                            let LastYear_varientAdr =
                                                (item?.ADR ? parseInt(item?.ADR) : 0) -
                                                (item?.ly_rate ? parseInt(item?.ly_rate) : 0);
                                            let LastYear_varientRev =
                                                (item?.REV ? parseInt(item?.REV) : 0) -
                                                (item?.ly_revenue ? parseInt(item?.ly_revenue) : 0);


                                            return (
                                                <React.Fragment key={index}>
                                                    <tr key={index} className="shadowOnHover">
                                                        <td style={{left: "0px", zIndex: 8}} className="border_right stickycolumn my-special-sticky" data-val={item?.[keyName]}>{item?.[keyName]}</td>
                                                        <td className="text-center" data-val={commonService.formateRoom(item?.RMS)}>{commonService.formateRoom(item?.RMS)}</td>
                                                        <td className={`text-center variance-font-size ${varientRms > 0 ? "greenText" : "redText"}`} data-val={commonService.formateRoom(varientRms).replace(/[^0-9.-]/g, "")}>{commonService.formateRoom(varientRms)}</td>
                                                        <td className="text-end" data-val={commonService.formateAmount(item?.ADR).replace(/[^0-9.-]/g, "")}>
                                                            {commonService.formateAmount(item?.ADR)}
                                                        </td>
                                                        <td className={`text-end variance-font-size ${varientAdr > 0 ? "greenText" : "redText"}`} data-val={commonService.formateAmount(varientAdr).replace(/[^0-9.-]/g, "")}>
                                                            {commonService.formateAmount(varientAdr)}
                                                        </td>
                                                        <td className="text-end" data-val={parseInt(Math.round(item?.REV ? item?.REV : 0))} data-val={commonService.formateAmount(item?.REV).replace(/[^0-9.-]/g, "")}>
                                                            {commonService.formateAmount(item?.REV)}
                                                        </td>
                                                        <td className={`text-end variance-font-size border_right ${varientRev > 0 ? "greenText" : "redText"}`} data-val={commonService.formateAmount(varientRev).replace(/[^0-9.-]/g, "")}>
                                                            {commonService.formateAmount(varientRev)}
                                                        </td>
                                                        <td className="text-center"  data-val={commonService.formateRoom(item?.ly_roomnight)}>
                                                            {commonService.formateRoom(item?.ly_roomnight)}
                                                        </td>
                                                        <td
                                                            className={`text-center variance-font-size ${LastYear_varientRms > 0 ? "greenText" : "redText"}`} data-val={commonService.formateRoom(LastYear_varientRms).replace(/[^0-9.-]/g, "")}>
                                                            {commonService.formateRoom(LastYear_varientRms)}
                                                        </td>
                                                        <td className="text-end" data-val={commonService.formateAmount(item?.ly_rate).replace(/[^0-9.-]/g, "")}>
                                                            {commonService.formateAmount(item?.ly_rate)}
                                                        </td>
                                                        <td
                                                            className={`text-end variance-font-size ${LastYear_varientAdr > 0 ? "greenText" : "redText"}`} data-val={commonService.formateAmount(LastYear_varientAdr).replace(/[^0-9.-]/g, "")}>
                                                            {commonService.formateAmount(LastYear_varientAdr)}
                                                        </td>
                                                        <td className="text-end" data-val={commonService.formateAmount(item?.ly_revenue).replace(/[^0-9.-]/g, "")}>
                                                            {commonService.formateAmount(item?.ly_revenue)}
                                                        </td>
                                                        <td className={`text-end variance-font-size border_right ${LastYear_varientRev > 0 ? "greenText" : "redText"}`} data-val={commonService.formateAmount(LastYear_varientRev).replace(/[^0-9.-]/g, "")}>
                                                            {commonService.formateAmount(LastYear_varientRev)}
                                                        </td>
                                                        <td className="text-center" data-val={totalRef.current?.revContri > 0 && item?.REV > 0
                                                            ? (
                                                                (parseInt(item?.REV) * 100) /
                                                                totalRef.current?.rev
                                                            )?.toFixed(1)
                                                            : 0}>
                                                            {totalRef.current?.revContri > 0 && item?.REV > 0
                                                                ? (
                                                                    (parseInt(item?.REV) * 100) /
                                                                    totalRef.current?.rev
                                                                )?.toFixed(1)
                                                                : 0}
                                                            %
                                                        </td>
                                                        <td className="text-center" data-val={Math.round(item?.LeadTime ? item?.LeadTime : 0)}>{Math.round(item?.LeadTime ? item?.LeadTime : 0)}</td>

                                                        <td className="text-center" data-val={item?.LOS.replace(/[^0-9.-]/g, "")}>{item?.LOS}</td>

                                                        <td className="text-center" data-val={(
                                                            (item?.ADR /
                                                                Math.round(
                                                                    totalRef.current?.rev /
                                                                    totalRef.current?.roomNight
                                                                )) *
                                                            100
                                                        ).toFixed(1)}>
                                                            {(
                                                                (item?.ADR /
                                                                    Math.round(
                                                                        totalRef.current?.rev /
                                                                        totalRef.current?.roomNight
                                                                    )) *
                                                                100
                                                            ).toFixed(1)}
                                                            %
                                                        </td>

                                                        <td className="border_right text-center" data-val={item?.["Occ_Threshold"].replace(/[^0-9.-]/g, "")}>
                                                            {item?.["Occ_Threshold"]}
                                                        </td>
                                                        <td className="text-end" data-val={commonService.formateAmount(
                                                            item?.["Displaced REV"]
                                                        ).replace(/[^0-9.-]/g, "")}>
                                                            {commonService.formateAmount(
                                                                item?.["Displaced REV"]
                                                            )}
                                                        </td>
                                                        <td className="text-center" data-val={item?.["Displaced REV %"].replace(/[^0-9.-]/g, "")}>
                                                            {item?.["Displaced REV %"]}
                                                        </td>
                                                        <td className="border_right text-end" data-val={commonService.formateAmount(
                                                            item?.["Cost/Benefit"]
                                                        ).replace(/[^0-9.-]/g, "")}>
                                                            {commonService.formateAmount(
                                                                item?.["Cost/Benefit"]
                                                            )}
                                                        </td>
                                                        <td className="text-end" data-val={commonService.formateAmount(item?.["Wish Rate"]).replace(/[^0-9.-]/g, "")}>
                                                            {commonService.formateAmount(item?.["Wish Rate"])}
                                                        </td>
                                                        <td className="text-end" data-val={commonService.formateAmount(item?.Opportunity).replace(/[^0-9.-]/g, "")}>
                                                            {commonService.formateAmount(item?.Opportunity)}
                                                        </td>
                                                    </tr>
                                                </React.Fragment>
                                            );
                                        })
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
                {api !== 0 && <Comments widgetDetails={para} editorId={"Account"} />}
            </div>
            {showSideBar && (
                <AccountFilter
                    showModal={showSideBar}
                    closeModal={closeSideBar}
                    filterData={filterRef.current}
                    updatePayload={updateFilter}
                />
            )}

            {showNoteSidebar && (
                <AddWidgetModal
                    showModal={showNoteSidebar}
                    closeModal={closeNoteSideBar}
                    widgetId={para?.widgetId}
                    propertyId={propertyDetailFromRTK?.propertyid}
                    rowTitle={para?.rowTitle}
                />
            )}
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}

            <Overlay
                show={filterModal.IsDisplay}
                target={filterModal.Target}
                placement={filterModal.Position}
            >
                <Popover
                    id="popover-contained"
                    className="SingleDateSummaryModalPopoverMain"
                >
                    <div className="horizontal-menu-option active reservationFilter">
                        <FilterModal
                            keyName={selectedFilterRef.current}
                            list={allFilterDataRef.current?.[selectedFilterRef.current]}
                            selectedData={
                                allSelectedDataRef.current?.[selectedFilterRef.current]
                            }
                            updateFilter={updateFilterModal}
                        />
                    </div>
                </Popover>
            </Overlay>
        </div>
    );
};

export default Account;
